import type { RootState } from '../types';

const EMPTY_ARRAY: readonly never[] = [];

export const customersSelectors = {
  basicList: (state: RootState) =>
    state.customers.basicCustomers || EMPTY_ARRAY,
};
